import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostDropChainProps {
    token: string;
    chain: string;
}

export const postDropChain: MutationFunction<
    AxiosResponse<any>,
    PostDropChainProps
> = async (props: PostDropChainProps) => {
    const { token, chain } = props;
    const headers = getDefaultHeaders(token);
    const dropChainJobUrl = `/jobs/${chain}/drop`;

    return axiosInstance().post(
        dropChainJobUrl,
        { chain },
        withHeaders(headers)
    );
};

export const useDropChain = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostDropChainProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postDropChain, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to create drop a chain job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
